export const css = {
	root: '_184vgusT',
	splash: '_7Pb3by2c',
	progressBar: '_103vs9EG',
	' _key': 'afcpe-theme/afcpe/micro/lcc-app/splash'
};

export default css;
